import script from "./ButtonWhatApp.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonWhatApp.vue?vue&type=script&setup=true&lang=js"

import "./ButtonWhatApp.vue?vue&type=style&index=0&id=b237d9c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b237d9c0"]])

export default __exports__